import React from 'react';
import { SlideLayout } from './SlideLayout';
import { Star, Sparkles } from 'lucide-react';
export function Slide7_Tiers() {
  const advantagePoints = ['Campaign success ambassadors', 'Campaign success manager', 'Two-day live sales school', 'Active KPI tracking', 'Ongoing consulting and campaign performance enhancement'];
  const tiers = [{
    name: 'ADVANTAGE',
    role: 'System Ownership',
    description: 'A recruiting system that actually works.',
    keyPoints: advantagePoints,
    highlight: true,
    bestFor: 'Teams that want consistency without giving up execution.'
  }, {
    name: 'SUMMIT',
    role: 'Full Execution',
    description: 'Recruiting execution handled for you.',
    keyPoints: advantagePoints,
    extraPoints: ['Dedicated recruiter capacity', 'Final interview execution', 'Enhanced pipeline management and onboarding support'],
    amber: true,
    bestFor: 'Teams that want recruiting off their plate.'
  }, {
    name: 'LEADERSHIP',
    role: 'Executive',
    description: 'Recruit leaders who scale your team.',
    keyPoints: ['Targeted campaigns for operators', 'Interviews handled for you', 'Performance aligned to team output'],
    mint: true,
    bestFor: 'Teams hiring managers and leaders to drive growth.'
  }];
  return <SlideLayout data-id="element-362" data-mp="v0rqs03y46jm">
      <div className="flex flex-col h-full justify-center space-y-16" data-id="element-363" data-mp="v09lkdzb2hzk">
        <div className="space-y-4 text-center" data-id="element-364" data-mp="qzfytnxln989">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-365" data-mp="r2u00suj1ce4">
            Three Levels of Partnership
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-366" data-mp="101fiyp3wutff">
            Designed to Support Where Your Business Is At Now and In the Future.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch max-w-6xl mx-auto" data-id="element-367" data-mp="36tgjkd51y6c1">
          {tiers.map((tier, idx) => {
          const mintStyle = tier.highlight || tier.mint;
          const containerClasses = mintStyle ? 'bg-slate-800/50 border-[#7FE0C3]/50 ring-2 ring-[#7FE0C3]/20 shadow-2xl' : tier.amber ? 'bg-slate-800/50 border-amber-500/50 ring-2 ring-amber-500/20 shadow-2xl' : 'bg-slate-900/30 border-slate-800';
          const rolePillClasses = mintStyle ? 'bg-[#7FE0C3]/20 text-[#7FE0C3]' : tier.amber ? 'bg-amber-500/20 text-amber-400' : 'bg-slate-800 text-slate-400';
          const bulletClasses = mintStyle ? 'bg-[#7FE0C3]' : tier.amber ? 'bg-amber-500/60' : 'bg-slate-600';
          return <div key={idx} className={`flex flex-col h-full rounded-xl border transition-all relative p-8 ${containerClasses}`} data-id="element-368" data-mp="27ezzmzw17ux6" data-mpi={idx}>
                {tier.highlight && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-[#7FE0C3] text-[#163A5F] text-xs font-bold uppercase tracking-wider rounded-full flex items-center space-x-1.5" data-id="element-369" data-mp="2mi1czkxdphlq">
                    <Star size={12} fill="currentColor" data-id="element-370" data-mp="2citsmds88mp4" />
                    <span data-id="element-371" data-mp="2cleswycvmukr">Flagship Partnership</span>
                  </div>}
                {tier.amber && <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-amber-500 text-slate-950 text-xs font-bold uppercase tracking-wider rounded-full flex items-center space-x-1.5" data-id="element-372" data-mp="358siuci5qpvd">
                    <Sparkles size={12} fill="currentColor" data-id="element-373" data-mp="2vho51g47xb24" />
                    <span data-id="element-374" data-mp="2vg39poa2xo37">Full Execution</span>
                  </div>}

                <div className="mb-6" data-id="element-375" data-mp="2reru8bkx6j8q">
                  <h3 className="text-3xl font-bold text-white mb-3" data-id="element-376" data-mp="3nzaa0cncddem">
                    {tier.name}
                  </h3>
                  <span className={`inline-block px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider ${rolePillClasses}`} data-id="element-377" data-mp="3j6z7d217vdid">
                    {tier.role}
                  </span>
                </div>

                <p className="text-slate-300 text-lg mb-8 leading-relaxed" data-id="element-378" data-mp="2upcbkqqjzts5">
                  {tier.description}
                </p>

                <div className="mb-8 flex-1" data-id="element-379" data-mp="2yrz64zelzst1">
                  <div className="space-y-3" data-id="element-380" data-mp="2ysr24bc4bsju">
                    {tier.keyPoints.map((point, pIdx) => <div key={pIdx} className="flex items-start" data-id="element-381" data-mp="3miuvlpvlebx4" data-mpi={pIdx}>
                        <span className={`mr-3 mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 ${bulletClasses}`} data-id="element-382" data-mp="3rf3bj5hm695c" />
                        <span className="text-slate-300" data-id="element-383" data-mp="3hp0aqj493qwg">{point}</span>
                      </div>)}
                  </div>

                  {tier.extraPoints && <div className="mt-6 p-4 rounded-lg bg-amber-500/10 border border-amber-500/40 space-y-3" data-id="element-384" data-mp="e18gmj0sxmj5">
                      <div className="flex items-center text-amber-400 text-xs font-bold uppercase tracking-wider" data-id="element-385" data-mp="1yqc5jpf9v6dv">
                        <Sparkles size={12} className="mr-2" data-id="element-386" data-mp="1tr9bf00tykko" />
                        <span data-id="element-387" data-mp="28gnmqdnyvc2p">Summit Difference</span>
                      </div>
                      {tier.extraPoints.map((point, pIdx) => <div key={pIdx} className="flex items-start" data-id="element-388" data-mp="23icbpzlxqviw" data-mpi={pIdx}>
                          <span className="mr-3 mt-1.5 h-1.5 w-1.5 rounded-full flex-shrink-0 bg-amber-400" data-id="element-389" data-mp="1frgfmqag5e5u" />
                          <span className="text-white font-medium" data-id="element-390" data-mp="1au859bvjief5">
                            {point}
                          </span>
                        </div>)}
                    </div>}
                </div>

                <div className={`pt-6 border-t ${tier.amber ? 'border-amber-500/20' : 'border-slate-800'}`} data-id="element-391" data-mp="315krddz99acz">
                  <p className="text-sm text-slate-400 leading-relaxed" data-id="element-392" data-mp="2w5q21ev4osu1">
                    {tier.bestFor}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </SlideLayout>;
}